/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $NativeWidgetToken = {
    properties: {
        store: {
            type: 'StoreEnum',
            isRequired: true,
        },
        token: {
            type: 'string',
            isRequired: true,
        },
        matchId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
